import React from 'react';

/** The five colors that identify a theme at a glance: primary, bars, page, surface, text. */
export const SWATCH_TOKENS = ['--color-primary', '--color-bar-bg', '--color-bg-page', '--color-bg-white', '--color-gray-900'];

/** A theme's swatch row, painted from its own tokens rather than the theme on screen. */
const ThemeSwatchRow = ({ tokens }) => (
  <span className="stui-theme-swatches">
    {SWATCH_TOKENS.map(n => (
      <span key={n} className="stui-theme-swatch" style={{ background: tokens?.[n] || 'transparent' }} />
    ))}
  </span>
);

export default ThemeSwatchRow;
